/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class t{constructor(t,e=0,s=0,r=0,i=0,o=null){this.usedMemory=t,this.displayedFeatures=e,this.totalFeatures=s,this.maximumFeatures=r,this.nodes=i,this.core=o}}function e(t){return"performanceInfo"in t}export{t as LayerViewPerformanceInfo,e as isPerformanceInfoLayerView};
